<template>
	<ApArt/>
</template>

<script>
import ApArt from './ApArt.vue'

export default {
	name: 'App',
	components: {
		ApArt
	}
}
</script>

<style>
body{
	margin: 0;
}
</style>
